export const LOGO_URL =
  "https://gogopowerjuice.com/cdn/shop/files/logo_with_phrase_180x.png?v=1613512380";

export const BRAND_NAME = "GoGoPowerJuice";
